"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuditLogSchema = void 0;
const transport_types_1 = require("@alliance-disposal/transport-types");
exports.AuditLogSchema = {
    name: 'audit-log',
    alias: 'Audit Log',
    shortName: 'history',
    applications: [],
    disabled: false,
    returnType: {
        aap: transport_types_1.AuditLog.AuditLogEntryTransport,
    },
    searchableAttributes: [],
    filterableAttributes: [],
    extraMappings: [],
};
//# sourceMappingURL=audit-log.js.map